import React from "react";
import { Link, useLocation } from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";

const InquiryTabs = () => {

    const { pathname, search } = useLocation();

    const inquiriesState = useAppSelector((state) => state.inquiries);

    const isUnansweredActive =
        !new URLSearchParams(search).get("tab") ||
        new URLSearchParams(search).get("tab") === "unanswered";
    const isAnsweredActive = new URLSearchParams(search).get("tab") === "answered";
    const isDraftsActive = new URLSearchParams(search).get("tab") === "drafts";

    const buildUrl = (tab: string) => {
        const params = new URLSearchParams(search);
        params.set("tab", tab);
        return `${pathname}?${params.toString()}`;
    };

    return (
        <ul className="tabs primary-nav">
            <li className={`tabs__item ${isUnansweredActive ? "active" : ""}`}>
                <Link to={buildUrl("unanswered")} className="tabs__link">
                    Vastamata <span style={{ color: "red", fontWeight: "bold" }}>{inquiriesState.countUnanswered}</span>
                </Link>
            </li>
            <li className={`tabs__item ${isAnsweredActive ? "active" : ""}`}>
                <Link to={buildUrl("answered")} className="tabs__link">
                    Vastatud <span style={{ color: "red", fontWeight: "bold" }}>{inquiriesState.countAnswered}</span>
                </Link>
            </li>
            <li className={`tabs__item ${isDraftsActive ? "active" : ""}`}>
                <Link to={buildUrl("drafts")} className="tabs__link">
                    Mustandid <span style={{ color: "red", fontWeight: "bold" }}>{inquiriesState.countDrafts}</span>
                </Link>
            </li>
        </ul>
    );
};

export default InquiryTabs;